// extracted by mini-css-extract-plugin
module.exports = {"loadingArea":"loading-area_loadingArea__2KPjc","loadingIndicator":"loading-area_loadingIndicator__1qd5n"};